import React from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { breakpoints, radius, spacing } from '@naf/theme';

export const Wrapper = styled.div`
  padding-top: 32px;

  :first-of-type {
    padding-top: 0;
  }
`;

// eslint-disable-next-line react/jsx-props-no-spreading
export const ListElement = styled((props) => <Link {...props} />)`
  cursor: pointer;
  text-decoration: none;
  display: flex;
  padding: 32px 0;

  :first-of-type {
    padding-top: 0;
  }

  border-bottom: 1px solid lightgrey;

  &:hover {
    border-radius: 4px;
    color: #1a1a1a !important;
    img,
    svg {
      transform: scale(1.05);
    }
    h3 {
      &::after {
        width: 100%;
      }
    }
  }
`;

export const ElementImage = styled.figure`
  overflow: hidden;
  border-radius: ${radius.s};
  margin: 0 ${spacing.space32} 0 0;
  width: 220px;
  position: relative;
  height: 166px;

  @media (max-width: ${breakpoints.s}) {
    width: 110px;
    height: calc(100px / (16 / 9));
    margin-right: ${spacing.space24};
  }

  z-index: 0;

  img {
    transition: transform 0.6s cubic-bezier(0.23, 1, 0.32, 1);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 106%;
    object-fit: cover;
  }
`;

export const ElementInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  h3 {
    width: auto;

    @media (min-width: ${breakpoints.s}) {
      width: max-content;
    }

    @media (max-width: ${breakpoints.s}) {
      font-size: 1.125rem;
    }

    position: relative;
    margin: 0;
    &::after {
      content: '';
      width: 0;
      height: 2px;
      transition: width 0.3s cubic-bezier(0.23, 1, 0.32, 1);
      background-color: #ffdb16;
      position: absolute;
      left: 0;
      bottom: -4px;
    }
  }
`;

export const PriceInfoWrapper = styled.div`
  margin-top: auto;
  margin-bottom: -6px;
`;

export const ElementPrice = styled.strong`
  margin-top: 1rem;
  font-weight: 500;
  font-size: 1.125rem;

  @media (max-width: ${breakpoints.s}) {
    font-size: 1rem;
  }
`;
